import React from 'react';

interface PublicRouteProps {
  children: React.ReactNode;
}

/**
 * Komponent dla stron publicznych, które nie wymagają autoryzacji
 * W przeciwieństwie do PrivateRoute, nie sprawdza stanu autoryzacji
 */
const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  // Strony publiczne nie wymagają żadnych sprawdzeń autoryzacji
  // Po prostu renderuj children bez żadnych warunków
  return <>{children}</>;
};

export default PublicRoute;